import { getFullName } from '@/lib/user'
import config from '@/config'
import common from './common'
import { formatDate } from '@/lib/date'

export default {
  ...common,
  link: item => `${config.web}/routine-executions/${item.id}`,
  description: item => item?.description,
  assignees: item =>
    item?.assignees?.map(assignee => getFullName(assignee)).join(', ') ?? '',
  routineDefinition: item => item?.routineDefinition,
  executedBy: item => getFullName(item.createdBy),
  executedAt: item => formatDate(item.createdAt),
}
